<template>
  <div :style="{height: screenHeight+'px'}">
    <div class="ys-container" style="position: absolute;top: 48px;width: 100%;height: calc(100% - 96px)"
         @dblclick="exportAsBase64"></div>
    <iframe
      src="https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/AB5756000/1.live&autoplay=1&accessToken=at.23zz2p0m5infyqa94b4h5sdfcd1ia1dx-9dcy97pz4g-04td7vw-ixzqkqz45&begin=开始时间&end=结束时间"
      width="100%"
      height="100%"
      id="ysOpenDevice"
      allowfullscreen
    >
    </iframe>
  </div>
</template>

<script>
import {getAccessToken} from '@/api/OtherService.js'
import html2Canvas from "html2canvas";

export default {
  name: 'YsyPlayer',
  components: {},
  props: {
    eqtId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      videoInfo: {
        url: ''
      },
      accessToken: '',
      key: new Date().getTime(),
      screenHeight: window.innerHeight,
    }
  },
  watch: {
    eqtId: {
      handler(val) {
        if (val) {
          this.getLiveUrl(val, 2)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    exportAsBase64() {
      const ele = document.getElementById('ysOpenDevice');
      html2Canvas(ele, {
        dpi: 96, // 分辨率
        scale: 2, // 设置缩放
        useCORS: true, // 允许canvas画布内跨域请求外部链接图片
        bgcolor: '#ffffff', // 背景颜色
        logging: false, // 不打印日志
        allowTaint: true, // 允许跨域
        scrollY: 0,
        scrollX: 0
      }).then((canvas) => {
        // 使用canvas的toDataURL方法将canvas转换为Base64图片
        const base64Image = canvas.toDataURL('image/png'); // 你可以根据需要更改'image/png'为'image/jpeg'等
        // 在这里你可以对base64Image做进一步处理，比如将其赋值给img元素的src，或者发送到服务器等
        // console.log(base64Image); // 打印Base64图片数据到控制台
        this.$emit('capture-picture', base64Image)
      }).catch((error) => {
        console.error('导出图片失败:', error);
      });
    },
    async accessToken() {
      const result = await getAccessToken({})
      if (result.code === "A00000") {
        if (result.data.length > 0) {
          const accessToken = result.data[0]
          this.accessToken = accessToken
          const dom = document.getElementsByClassName('ys-container')[0]
          const player = new window.EZUIKit.EZUIKitPlayer({
            id: `video-container-${this.key}-${this.eqtId}`, // 视频容器ID
            accessToken,
            width: dom.clientWidth,
            height: dom.clientHeight,
            url: `ezopen://open.ys7.com/${this.eqtId}/1.live`,
            audio: 0,
            staticPath: '/lib/ys/v6',
            handleError: () => {
              setTimeout(() => {
                player.play()
              }, 1000)
            }
          })
          this.$nextTick(() => {
            player.play()
          })
        } else {
          this.$message.error('获取accessToken失败')
        }
      }
    },
    async accessToken2() {
      const result = {
        "rowCount": 1,
        "pageCount": 0,
        "totalCount": 0,
        "data": [
          "at.1s5sed5y0sysa0epcl2562n74gx224xx-51e51jbhds-1oad8v0-khoeffj2o"
        ],
        "code": "A00000",
        "message": "成功",
        "xid": "c2d5ad990b8c487d"
      };
      if (result.code === "A00000") {
        if (result.data.length > 0) {
          const accessToken = result.data[0]
          this.accessToken = accessToken
          const dom = document.getElementsByClassName('ys-container')[0]
          console.log(111111111);
          console.log(dom);
          console.log(accessToken);
          console.log(EZUIKit);
          const player = new EZUIKit.EZUIKitPlayer({
            id: `video-container-${this.key}-${this.eqtId}`, // 视频容器ID
            accessToken,
            width: dom.clientWidth,
            height: dom.clientHeight,
            url: `ezopen://open.ys7.com/${this.eqtId}/1.live`,
            audio: 0,
            staticPath: '/lib/ys/v6',
            handleError: () => {
              setTimeout(() => {
                player.play()
              }, 1000)
            }
          })
          this.$nextTick(() => {
            player.play()
          })
        } else {
          this.$message.error('获取accessToken失败')
        }
      }
    },
    getLiveUrl(deviceSerial, protocol) {
    }
  }
}
</script>

<style scoped>
.ys-container {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/player/YsyPlayer.vue